// removed by extract-text-webpack-plugin
module.exports = {"player-name":"_2OOIOcI8XLhLL2YZgj9RpA_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"id":2,"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a643ce5a","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"strictMath":"on","sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src.player/ui/events/events/nomination/preview.vue
// module id = 229
// module chunks = 0